import React, { useState } from 'react';
import {
  Boxes, FileText, GraduationCap, Settings2, ShieldAlert, Sparkles,
} from 'lucide-react';

import ComplianceDocumentsPanel from './ComplianceDocumentsPanel';
import EquipmentPanel from './EquipmentPanel';
import IncidentPanel from './IncidentPanel';
import RoutinePanel from './RoutinePanel';
import SterilizationPanel from './SterilizationPanel';
import TrainingPanel from './TrainingPanel';


const MODULES = [
  { id: 'documents', title: 'Documentos', description: 'Arquivos e revisões', icon: FileText, color: 'text-purple-700 bg-purple-50' },
  { id: 'training', title: 'Equipe', description: 'Capacitações', icon: GraduationCap, color: 'text-teal-700 bg-teal-50' },
  { id: 'sterilization', title: 'Esterilização', description: 'Cargas e indicadores', icon: Sparkles, color: 'text-emerald-700 bg-emerald-50', internalOnly: true },
  { id: 'equipment', title: 'Equipamentos', description: 'Manutenções e calibrações', icon: Settings2, color: 'text-indigo-700 bg-indigo-50' },
  { id: 'routines', title: 'Rotinas', description: 'Controles recorrentes', icon: Boxes, color: 'text-cyan-700 bg-cyan-50' },
  { id: 'incidents', title: 'Ocorrências', description: 'Ações de melhoria', icon: ShieldAlert, color: 'text-rose-700 bg-rose-50' },
];

const ComplianceModulesHub = ({ canManage, processingType, hasVacuumPump }) => {
  const [selected, setSelected] = useState(null);
  const modules = MODULES.filter((item) => !item.internalOnly || processingType === 'internal');

  const renderSelected = () => {
    if (selected === 'documents') return <ComplianceDocumentsPanel canManage={canManage} initialExpanded />;
    if (selected === 'training') return <TrainingPanel canManage={canManage} initialExpanded />;
    if (selected === 'sterilization') return <SterilizationPanel canManage={canManage} hasVacuumPump={hasVacuumPump} initialExpanded />;
    if (selected === 'equipment') return <EquipmentPanel canManage={canManage} initialExpanded />;
    if (selected === 'routines') return <RoutinePanel canManage={canManage} initialExpanded />;
    if (selected === 'incidents') return <IncidentPanel canManage={canManage} initialExpanded />;
    return null;
  };

  return <section className="rounded-2xl bg-white p-5 shadow-sm sm:p-6">
    <div><h3 className="font-semibold text-gray-900">Controles da clínica</h3><p className="mt-1 text-sm text-gray-500">Abra somente a área que deseja consultar ou atualizar.</p></div>
    <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
      {modules.map((item) => {
        const Icon = item.icon;
        const active = selected === item.id;
        return <button key={item.id} type="button" onClick={() => setSelected(active ? null : item.id)} className={`rounded-xl border p-3 text-left transition ${active ? 'border-purple-400 bg-purple-50 ring-1 ring-purple-100' : 'border-gray-200 hover:border-purple-200 hover:bg-gray-50'}`}><span className={`inline-flex rounded-lg p-2 ${item.color}`}><Icon className="h-4 w-4" /></span><span className="mt-2 block text-sm font-semibold text-gray-900">{item.title}</span><span className="mt-0.5 block text-xs text-gray-500">{item.description}</span></button>;
      })}
    </div>
    {selected && <div className="mt-5 border-t pt-5">{renderSelected()}</div>}
  </section>;
};

export default ComplianceModulesHub;
